module.exports = "/images/vendor/lightgallery/src/vimeo-play.png?dfe7764b4fe444c3880736ac6131f5b4";